import { onBeforeMount } from 'vue'
import { AdMediatorOptions } from '@/modules/adv-service'
import { useAdsStore } from '@/store/ads-store'

export const useSetPageData = (updateTargeting: () => AdMediatorOptions['targeting'] | undefined) => {
    const adsStore = useAdsStore()

    // eslint-disable-next-line no-restricted-syntax
    onBeforeMount(() => {
        const targeting = updateTargeting()
        if (targeting) {
            adsStore.updateTargeting(targeting)
        }
    })
}
